import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttFormSelect } from '../all';

export const GENDER = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    UNKNOWN: 'UNKNOWN',
    OTHER: 'OTHER',
};

type Props = {
    grid?: boolean;
    xs?: number;
    md?: number;
    caption?: string;
    name: string;
    defVal?: string;
    onChange: (event: { name: string | undefined; value: unknown }) => void;
    [key: string]: unknown;
};

export function SttSelectGender({
    grid = false,
    xs = 12,
    md = 3,
    _caption,
    name,
    defVal = GENDER.UNKNOWN,
    onChange,
    ...rest
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const content = (
        <SttFormSelect
            {...rest}
            name={name}
            defVal={defVal}
            caption={t('labels.gender')}
            options={[
                { caption: t('genders.male'), value: GENDER.MALE },
                { caption: t('genders.female'), value: GENDER.FEMALE },
                { caption: t('labels.other'), value: GENDER.OTHER },
                { caption: t('labels.unknown'), value: GENDER.UNKNOWN },
            ]}
            onChange={onChange as any}
        />
    );

    return grid ? <Grid size={{ xs, md }}>{content}</Grid> : content;
}
